export enum FilterContext {
    Initial = 'initial',
    Dynamic = 'dynamic',
}
